import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export async function getAll(p = {}) {
  try {
    const params = new URLSearchParams({ ...p })
    const response = await apiCMSWithToken.get(
      `${F18_SERVICES.projects}?${params.toString()}`
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function addProject(body) {
  try {
    const response = await apiCMSWithToken.post(F18_SERVICES.projects, body)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function updateProject(body, id) {
  try {
    const response = await apiCMSWithToken.put(
      `${F18_SERVICES.projects}/${id}`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}
export async function detailProject(id) {
  try {
    const response = await apiCMSWithToken.get(`${F18_SERVICES.projects}/${id}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function deleteProject(body) {
  try {
    const response = await apiCMSWithToken.post(
      `${F18_SERVICES.projects}/deletes`,
      body
    )
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function projectImportExcel(body) {
  try {
    const response = await apiCMSWithToken.post(
      `${F18_SERVICES.projects}/import/excel`,
      body,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return response
  } catch (error) {
    console.error('Error in projectImportExcel:', error)
    throw error
  }
}

export default {
  getAll,
  addProject,
  updateProject,
  detailProject,
  deleteProject,
  projectImportExcel
}
